import { Component, Input, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import * as L from 'leaflet';


@Component({
  selector: 'app-mapa-alcaldias',
  templateUrl: './mapa-alcaldias.component.html',
  styleUrls: ['./mapa-alcaldias.component.scss']
})
export class MapaAlcaldiasComponent implements OnInit, AfterViewInit {
  map: any;

  @Input() alcaldias: any;

  constructor() { }

  ngOnInit(): void { }

  ngAfterViewInit() {
    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    function ScaledRadius(val: number, maxVal: number): number {
      return 50 * (val / maxVal);
    }

   this.map = L.map('mapAlcaldias', { scrollWheelZoom: false }).setView([19.369903, -99.148074], 11);

   L.tileLayer('http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
			maxZoom: 16,
			minZoom: 10,
		}).addTo(this.map);

    const maxVal = Math.max(...this.alcaldias.filters.map(x => x.count_confirmados), 0);
    let flymf = {
      "color": "#fff",
      "fillColor": "4F5D9F",
      "weight": 1,
      "opacity": 0.75
    }

    L.geoJSON(this.alcaldias.alcaldias, { style: flymf }).addTo(this.map);

    this.alcaldias.filters.map((el) => {
      let div_circle = L.divIcon({ className: "circle" });
      L.circleMarker([el.geo_point_2d.split(",")[0],el.geo_point_2d.split(",")[1]], {
        radius: ScaledRadius(el.count_confirmados, maxVal),
        fillOpacity: 1,
        color: "#4F5D9F",
        fillColor: "#4F5D9F",
        weight: 1,
        className: "circle"
      })
      .bindTooltip(`${ Number(el.count_confirmados).toLocaleString('es-MX', { maximumFractionDigits: 2 }) }`, {
        permanent: true,
        opacity: 1,
        direction: 'center',
        className: 'leaflet-tooltip',
        offset: [0, 0]
      })
      .addTo(this.map);

    });

    function colorlayer(feature, layer) {
      layer.on('mouseover', function (e) {
        layer.setStyle({
          fillOpacity: 0.4
        });
      });
      layer.on('mouseout', function (e) {
        layer.setStyle({
          fillOpacity: 0
        });
      });
    }
  }
}
